// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2316ad06","455":"ee05d31a","977":"8bc6e9c6"}[chunkId] + ".chunk.js";
};